
<div *ngIf="issues; else loadingIssues;">
  <ul>
    <li *ngFor="let item of issues| async">
       {{ item | json }}
    </li>
  </ul>
</div>
<ng-template #loadingIssues>
  <div>Loading ...</div>
</ng-template> 

  
  


// WEBPACK FOOTER //
// C:/Users/VML/Desktop/vml6/src/app/test/test.component.html